/* global videojs */
const buttons = document.querySelectorAll('.video-box__button');

function videoBoxPlay(button) {
  const container = button.closest('.video-box__container');
  const content = container.querySelector('.video-box__content');
  const player = container.querySelector('.video-box__player');

  if (player.tagName === 'VIDEO-JS') {
    if (!videojs) return;
    const videoJsPlayer = window.initLazyVideoJsPlayer
      ? window.initLazyVideoJsPlayer(player)
      : videojs(player);
    videoJsPlayer.ready(function () {
      this.controls(true);
      this.play();
    });
    container.classList.add('fade');
    content.remove();
  } else if (player.tagName === 'VIDEO') {
    player.play();
    player.controls = true;
    container.classList.add('fade');
    content.remove();
  }
}

buttons.forEach((button) => {
  button.addEventListener('click', (event) => {
    videoBoxPlay(event.target);
  });
});
